export default {
  hero: {
    eyebrow: "Le centre de ressources Basetao Spreadsheet",
    h1: "Basetao Spreadsheet : trouvez des produits, comparez les vendeurs et achetez malin",
    desc: "Explorez des ressources Basetao Spreadsheet organisées, des trouvailles produits, des guides vendeurs, des infos QC, des guides d'expédition, des avis et des conseils d'achat pratiques — le tout dans un hub rapide et consultable.",
    secondary: "Vous cherchez des produits, vérifiez un vendeur, comparez les options d'expédition ou vous demandez si Basetao est fiable ? Commencez ici.",
    trust: "Ressource indépendante · Mise à jour régulière · Axée sécurité · Multilingue",
  },
  popular: {
    title: "Sujets populaires",
  },
  value: {
    h2: "Tout ce qu'il faut pour comprendre Basetao",
    sub: "Un point de départ clair et honnête pour la recherche de produits, la vérification des vendeurs et des achats plus sûrs.",
    card1: {
      title: "Ressources Spreadsheet",
      desc: "Des ressources produits et catégories organisées pour parcourir les trouvailles plus vite.",
    },
    card2: {
      title: "Recherche de vendeurs",
      desc: "Apprenez à comparer les vendeurs et à évaluer les infos produit avant de commander.",
    },
    card3: {
      title: "Guides QC",
      desc: "Comprenez les photos QC et ce qu'il faut vérifier avant l'expédition de vos articles.",
    },
    card4: {
      title: "Guides d'expédition",
      desc: "Maîtrisez le poids, le poids volumétrique, les lignes d'expédition et l'assurance.",
    },
    card5: {
      title: "Avis indépendants",
      desc: "Des articles équilibrés couvrant l'expérience, les frais, l'entrepôt et les risques.",
    },
    card6: {
      title: "La sécurité avant tout",
      desc: "Repérez les faux liens, les remises trompeuses et les demandes de paiement risquées.",
    },
  },
  about: {
    h2: "Qu'est-ce que Basetao Spreadsheet ?",
    p1: "Basetao Spreadsheet désigne les ressources partagées et organisées utilisées pour découvrir des produits, comparer les vendeurs et suivre les articles avant de passer commande. Cela transforme des liens produits dispersés en un plan d'achat plus clair.",
    p2: "Comme les données produit et les détails vendeur évoluent vite, nous expliquons surtout comment ces ressources fonctionnent et ce qu'il faut vérifier — plutôt que de présenter des prix fixes ou des garanties.",
  },
  review: {
    h2: "Basetao est-il fiable ? Lisez les preuves avant d'acheter",
    copy: "Nos contenus séparent les faits, les retours d'utilisateurs et l'analyse éditoriale pour que vous puissiez décider par vous-même.",
    cta: "Lire le guide « Basetao est-il fiable »",
  },
  shipping: {
    h2: "Frais d'expédition Basetao : qu'est-ce qui influence vraiment le prix ?",
    copy: "Les frais d'expédition peuvent dépendre de la destination, du poids, du poids volumétrique, de la ligne choisie, des dimensions, de l'assurance et d'autres facteurs.",
    cta: "En savoir plus sur les frais d'expédition",
  },
  safety: {
    h2: "Achetez malin. Vérifiez avant de payer.",
    item1: "Vérifiez les URL avant de cliquer",
    item2: "Ne partagez jamais vos mots de passe",
    item3: "Vérifiez soigneusement les vendeurs",
    item4: "Vérifiez les preuves produit",
    item5: "Vérifiez les coupons",
    item6: "Comprenez les conditions d'expédition",
    cta: "Ouvrir la liste de sécurité",
  },
  articleSection: {
    h2: "Commencez par notre guide approfondi",
    copy: "Vous vous demandez si Basetao est légitime et comment rester en sécurité ? Lisez notre article complet, rédigé de façon indépendante.",
    cta: "Lire l'article complet",
  },
  guides: {
    h2: "Guides approfondis sur Basetao",
    sub: "Dix guides originaux et rédigés de façon indépendante sur les produits, les vendeurs, le QC, l'expédition, l'entrepôt, les coupons, la sécurité et les comparaisons.",
  },
  cta: {
    h2: "Prêt à explorer les ressources Basetao Spreadsheet ?",
    copy: "Commencez par le guide principal, puis explorez les produits, les vendeurs, le QC, l'expédition, les avis et la sécurité.",
    primary: "Basetao Spreadsheet",
    secondary: "Acheter maintenant",
  },
};